function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ReactNode } from 'react';
import cn from 'classnames';
require("./PriceSummaryItem.css");
var styles = {
  "Separator": "PriceSummaryItem-module-Separator_5wQ",
  "Root": "PriceSummaryItem-module-Root_p5Z",
  "Name": "PriceSummaryItem-module-Name_rwv",
  "Value": "PriceSummaryItem-module-Value_2jo",
  "hasAccent": "PriceSummaryItem-module-hasAccent_2f8"
};
export const PriceSummaryItemTags = {
  li: 'li',
  div: 'div'
};
export const PriceSummaryItem = ({
  name,
  value,
  className,
  controlRef,
  innerRef,
  hasSeparator = false,
  hasAccent = false,
  tag = PriceSummaryItemTags.li
}) => {
  const PriceSummaryItemTag = tag;
  return /*#__PURE__*/React.createElement(PriceSummaryItemTag, _extends({}, tag === PriceSummaryItemTags.div && {
    role: 'listitem'
  }, {
    className: cn(styles.Root, className, {
      [styles.hasAccent]: hasAccent
    }),
    ref: innerRef || controlRef
  }), hasSeparator ? /*#__PURE__*/React.createElement("hr", {
    className: styles.Separator
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.Name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles.Value
  }, value));
};
if (process.env.NODE_ENV !== 'production') {
  PriceSummaryItem.displayName = 'PriceSummaryItem';
}